// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Components
import { PagesComponent } from './pages.component';

/**
 * Routes
 */
const routes: Routes = [
  {path: '', component: PagesComponent}
];

/**
 * Pages Routing Module
 */
@NgModule({
  imports: [
    // Angular
    RouterModule.forChild(routes),
  ],
  exports: [
    // Angular
    RouterModule,
  ]
})
export class PagesRoutingModule {
}
